import React from 'react';

export default function StartTalentAssessment() {
  return (

    <>
      <h1>Talent Assessment</h1>

      <p className="mt-5">
        This assessment is designed to measure your natural tendencies across
        12 key productivity and wellbeing dimensions. Your results, available
        immediately after completion, will create a comprehensive picture of
        your strengths and development opportunities. Let&apos;s uncover your
        leadership potential!
      </p>
    </>

  );
}
